// extracted by mini-css-extract-plugin
module.exports = {"nav":"NavigationItem_nav__QHwPm","active":"NavigationItem_active__3i0Bk"};